import { useRef } from 'react';
import { useReactNodeView } from '../utils/ReactNodeView';
import { CALYPSO, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_BACKGROUND_COLOR = CALYPSO_LIGHT;
const DEFAULT_BORDER_COLOR = CALYPSO_LIGHT;
const DEFAULT_FONT_COLOR = CALYPSO;
const StyledToken = styled.span.withConfig({
  displayName: "PersonalizationTokenView__StyledToken",
  componentId: "sc-1l32vtp-0"
})(["background-color:", ";border:1px solid ", ";border-radius:2px;color:", ";cursor:default;display:inline;line-height:1;margin:0;padding:4px 8px;vertical-align:middle;user-select:text;width:auto;"], props => props.backgroundColor || DEFAULT_BACKGROUND_COLOR, props => props.borderColor || DEFAULT_BORDER_COLOR, props => props.fontColor || DEFAULT_FONT_COLOR);
export function PersonalizationTokenView() {
  const {
    node
  } = useReactNodeView();
  const attrs = useRef(node ? node.attrs : {});
  return /*#__PURE__*/_jsx(StyledToken, {
    backgroundColor: attrs.current.tokenStyles.backgroundColor,
    borderColor: attrs.current.tokenStyles.borderColor,
    fontColor: attrs.current.tokenStyles.fontColor,
    className: "ProseMirror__personalizationToken",
    children: attrs.current.displayText || attrs.current.tokenKey
  });
}
PersonalizationTokenView.displayName = 'PersonalizationTokenView';
export function personalizationTokenViewUpdateFn({
  previousNode,
  node
}) {
  if (previousNode.attrs.tokenKey !== node.attrs.tokenKey) {
    return false;
  }
  return true;
}